import React from 'react';
import classNames from 'classnames';
import { Pebbles, PebbleSizeEnum } from '@/enums/pebbles';
import { getTailwindClassByEnum } from '@/utils/cssHelpers';
import { compose } from '@/utils/story-composer';
import { FillColorEnum } from '@/enums/styling';

function Pebble({ elementProps, content, pebbleType, color, size }) {
	const pebblePath = Pebbles[pebbleType] || Pebbles.PEBBLE_A;
	const pebbleSizeClass = getTailwindClassByEnum(PebbleSizeEnum, size);
	const pebbleFillColorClass = getTailwindClassByEnum(FillColorEnum, color) || FillColorEnum.MARINER_EXTRA_LIGHT;

	return (
		<div {...elementProps} className={classNames('relative', pebbleSizeClass)}>
			<svg viewBox="0 0 120 120" version="1.1">
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="pebble">
						<rect id="box" x="0" y="0" width="120" height="120" />
						<path d={pebblePath} className={pebbleFillColorClass} />
					</g>
				</g>
			</svg>
			<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">{content}</div>
		</div>
	);
}

export default Pebble;

compose('pebble', Pebble, { children: ['content'] });
